import React, { Component } from 'react'
import Outernavbar from './outernavbar.component'
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';

const PrivacyAndTerms = () => {


      const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
   // maxWidth: '1400px',
    margin: 'auto',
    lineHeight: '2.1',
    background: '#f9f9f9',
    width: '100%',
    fontSize: '23px'
  };

  const containerStyle1 = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    maxWidth: '1400px',
    margin: 'auto',
    lineHeight: '1.6',
    background: '#f9f9f9',
    width: '100%'
  };

  const headingStyle = {
    color: '#2a2a2a',
  };

  const listStyle = {
    marginLeft: '20px',
  };

  const linkStyle = {
    color: '#007BFF',
    textDecoration: 'none',
  };

    return(<>
        <div style={containerStyle}>
           
            <div style={containerStyle1}>
                <h1 style={headingStyle} >User Agreement</h1>
  <p><strong>Last Updated:</strong> June 1, 2025</p>
  <p>This User Agreement ("Agreement") governs your use of the services provided by Event Trackit. By accessing or using our services, you agree to be bound by the terms outlined in this Agreement.</p>
  <h2 style={headingStyle}>1. Account Registration</h2>
  <p>You must create an account with accurate information. You are responsible for all activities under your account.</p>
  <h2 style={headingStyle}>2. Use of Services</h2>
  <p>You agree to use our services lawfully. Prohibited activities include:</p>
  <ul style={listStyle}>
    <li>Violating laws or regulations</li>
    <li>Infringing on intellectual property</li>
    <li>Fraud or deception</li>
    <li>Distributing malicious content</li>
  </ul>
  <h2 style={headingStyle}>3. Payment Terms</h2>
  <p>Some services require payment. You agree to pay applicable fees. Payments are secure and follow our Privacy Policy.</p>
  <h2 style={headingStyle}>4. Termination</h2>
  <p>We may suspend or terminate access if you violate this agreement. Your right to use our services ends upon termination.</p>
  <h2 style={headingStyle}>5. Limitation of Liability</h2>
  <p>We are not liable for indirect or consequential damages arising from your use of our services.</p>
  <p>Email: <a href="mailto:support@eventtrackit.com">support@eventtrackit.com</a></p>
  <h2 style={headingStyle}>6. Indemnification</h2>
  <p>You agree to indemnify Event Trackit and its team from claims or damages due to your use or violation of this agreement.</p>
  <h2>7. Governing Law</h2>
  <p>This Agreement is governed by the laws of the jurisdiction in which Event Trackit operates.</p>
  <h2>8. Dispute Resolution</h2>
  <p>Disputes will be resolved through binding arbitration per American Arbitration Association rules.</p>
  <h2>9. Modifications</h2>
  <p>We may update this Agreement. Continued use means acceptance of the changes.</p>
  
  <h2 style={headingStyle}>10. Contact Us</h2>
  <p>
    Event Trackit<br/>
    Email: <a href="mailto:support@eventtrackit.com" style={linkStyle}>support@eventtrackit.com</a><br/>
    Website: <a href="https://eventtrackit.com" target="_blank" style={linkStyle}>eventtrackit.com</a>
  </p>

            </div>
        </div>
   </> );
};

export default PrivacyAndTerms;
